// extracted by mini-css-extract-plugin
export default {"root":"_2kr0S-YLqE"};